import React, {
    useEffect,
    useState,
    useContext
} from 'react';
import {
    Link,
} from 'react-router';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import EditIcon from '@mui/icons-material/Edit';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { getAuth } from 'firebase/auth';
import { ref, get, onChildChanged } from 'firebase/database';
import { useFirebase } from '../firebase-context';
import CrudContext from './crud-context';
import AppContext from '../app-context';
import ModelTypes from './model-types';
import { useNavigation } from '@toolpad/core/useNavigation';
import crudDefinitions from './crud-defs';
import { Menu } from '@mui/material';


const List = ({ definition }) => {
    const navigate = useNavigation();
    const { accessLevel } = useContext(AppContext);
    const { user, db } = useFirebase();
    const [storageKeySuffix, setStorageKeySuffix] = useState('');

    const [entityState, setXEntityState] = useState({});
    const [formState, setXFormState] = useState({});

    const providerValue = {
        ...{ fields: [], storageKey: '', crumbs: [] },
        ...crudDefinitions[definition],
        entityState,
        setEntityState,
        formState,
        setFormState,
        hardSetFormState,
        hardSetEntityState
    };
    
    // function startNewItem() {
    //     const { modelType } = providerValue;
    //     const newid = uuid.generate();
    //     let newUrl = `./${newid}`;
    //     if (modelType === ModelTypes.USEROWNEDLIST && accessLevel === 1 && user) {
    //         const { uid } = user;
    //         newUrl = `./${uid}%2F${newid}`
    //     }
    //     navigate(newUrl);
    // }

    function setEntityState(newState) {
        setXEntityState({
            ...entityState,
            ...newState
        });
    }

    function hardSetEntityState(newState) {
        setXEntityState(newState);
    }

    function setFormState(newState) {
        setXFormState({
            ...formState,
            ...newState
        });
    }

    function hardSetFormState(newState) {
        setXFormState(newState);
    }

    const [userHasAccess, setUserHasAccess] = useState(true);
    const [listState, setListState] = useState([]);

    const {
        modelType,
        crudLabel,
        listAccessors,
        storageKey
    } = providerValue;
    
    
    let dbRef = `/${storageKey}${storageKeySuffix}`;

    let snapshotReducer = (snapshot) => { // client userownedlist reducer
        const payload = snapshot.val();
        if (payload === null) return {};

        return Object.keys(payload).reduce((acc, cur) => ({
            ...acc,
            [cur]: {
                ...payload[cur],
                account: uid
            }
        }), {});
    };

    if (modelType === ModelTypes.SOLO) { // solo reducer
        snapshotReducer = (snapshot) => snapshot.val() || {};
    }

    let editLinkFn = (id) => `./${id}`;
    const { uid } = getAuth().currentUser;
    const mayAccessTopLevelList = accessLevel >= 2;
    
    if (mayAccessTopLevelList && modelType === ModelTypes.USEROWNEDLIST) {
        snapshotReducer = (snapshot) => { // employee userownedlist reducer
            const payload = snapshot.val();
            if (payload === null) return {};
            return Object.keys(payload).reduce((acc, cur) => ({
                ...acc,
                ...Object.keys(payload[cur]).map((subkey) => ({
                    [`${cur}%2F${subkey}`]: {
                        ...payload[cur][subkey],
                        account: cur
                    }
                })).reduce((acc, cur) => ({
                    ...acc,
                    ...cur
                }), {})
            }), {});
        };
    }

    // if (!mayAccessTopLevelList) {
    //     dbRef = `/${storageKey}/${uid}`;
    //     editLinkFn = (id) => `./${uid}%2F${id}`;
    // }

    useEffect(() => {
        // setCrumbs([{ url: '', label: `${crudLabel}s` }]);
        onChildChanged(ref(db, dbRef), (snapshot) => {
            setListState(snapshotReducer(snapshot));
        });
        get(ref(db, dbRef))
            .then((snapshot) => {
                setUserHasAccess(true);
                setListState(snapshotReducer(snapshot));
            })
            .catch((e) => {
                setUserHasAccess(false);
            });
        ///// let newRef = firebase.database().ref(dbRef);
        ///// newRef.onDisconnect().cancel();
        ///// newRef.on('child_changed', (snapshot) => {
        /////    setListState(snapshotReducer(snapshot));
        /////    // toast external change
        ///// });
        ///// newRef.once('value')
        /////     .then((snapshot) => {
        /////         setUserHasAccess(true);
        /////         setListState(snapshotReducer(snapshot));
        /////     })
        ///////     .catch((e) => {
        ///////         console.log(e);
        ///////         setUserHasAccess(false);
        ///////     });
        /////// return () => newRef.off();
    }, [crudLabel, accessLevel, db, storageKeySuffix]);

    if (!userHasAccess) return (<Redirect to={`/${storageKey}/${uid}`} />);

    return (<div>
        <Card style={ { overflowX: 'auto', maxWidth: '80vw'}}>
            <CardContent>
                <Select
                    displayEmpty
                    value={ storageKeySuffix }
                    onChange={ (e) => setStorageKeySuffix(e.target.value) }
                >
                    <MenuItem value="">Open</MenuItem>
                    <MenuItem value="-archive">Archived</MenuItem>
                </Select>
                <Table aria-label={`${crudLabel}s`}>
                    <TableHead>
                        <TableRow>
                            <TableCell />
                            {
                                listAccessors.map((listAccessor) => (
                                    <TableCell style={ { textTransform: 'capitalize' } } key={ listAccessor } align="right">{ listAccessor }</TableCell>
                                ))
                            }
                        </TableRow>
                    </TableHead>
                    <TableBody>
                    {Object.keys(listState).map((k) => (
                        <TableRow key={k}>
                            <TableCell>
                                <Link to={ editLinkFn(k) }>
                                    <EditIcon />
                                </Link>
                            </TableCell>
                            {
                                listAccessors.map((listAccessor) => (
                                    <TableCell key={ listAccessor } align="right">{listState[k][listAccessor]}</TableCell>
                                ))
                            }
                        </TableRow>
                    ))}
                    </TableBody>
                </Table>
            </CardContent>
        </Card>
    </div>)
};

export default List;
